// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails";
import "./controllers";

import "trix";
import "@rails/actiontext";
import "preline";
import "chartkick/chart.js";
import "./invoice_element";

document.addEventListener("turbo:load", () => {
	window.HSStaticMethods.autoInit();
});

Turbo.config.forms.confirm = (message, element) => {
	let dialog = document.getElementById("turbo-confirm");
	if (!dialog) {
		dialog = document.createElement("dialog");
		dialog.id = "turbo-confirm";
		dialog.classList.add(..."relaitve z-10".split(" "));
		dialog.innerHTML = `
            <div class="fixed inset-0 bg-gray-500/90 transition-opacity" aria-hidden="true"></div>
<div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
<div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
        <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
              </svg>
            </div>

<div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
              <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">Are you sure?</h3>
              <div class="mt-2">
                    <p class="text-sm text-gray-500">${message}</p>
              </div>
            </div>
          </div>
        </div>

 <form method="dialog">
                        <div class="px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 space-x-3">
                            <button value="confirm" class="btn btn-danger ml-2">
                                Yes, I'm sure
                            </button>
                            <button value="cancel"  class="btn btn-outline mr-2">No, cancel</button>
                        </div>
                    </form>


                   `;
		document.body.appendChild(dialog);
	}

	dialog.showModal();

	return new Promise((resolve, reject) => {
		dialog.addEventListener(
			"close",
			(e) => {
				dialog.remove();
				resolve(dialog.returnValue == "confirm");
			},
			{ once: true },
		);
	});
};
